var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOptoHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 760.413,
    height: 538.528,
    viewBox: "0 0 760.413 538.528",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y1: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y1: 1,
    y2: 0,
    xlinkHref: "#prefix__linear-gradient"
  }), /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1,.prefix__cls-6{fill:#50aeb0}.prefix__cls-1,.prefix__cls-4{opacity:.1}.prefix__cls-3{fill:#fff}.prefix__cls-5{fill:#cf6f80}.prefix__cls-7{fill:#3f3d56}.prefix__cls-11{fill:#9d9cb5}.prefix__cls-12{fill:none;stroke:#535461;stroke-miterlimit:10;stroke-width:2px}.prefix__cls-14{fill:#1d2366}.prefix__cls-15{fill:#ffb0b1}.prefix__cls-17{opacity:.03}.prefix__cls-18{fill:#dce7ff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__undraw_medicine_b1ol",
    transform: "translate(.005 .006)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "prefix__Ellipse_9",
    cx: 67.038,
    cy: 10.767,
    className: "prefix__cls-1",
    "data-name": "Ellipse 9",
    rx: 67.038,
    ry: 10.767,
    transform: "translate(185.868 516.684)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "prefix__Ellipse_10",
    cx: 83.654,
    cy: 10.767,
    className: "prefix__cls-1",
    "data-name": "Ellipse 10",
    rx: 83.654,
    ry: 10.767,
    transform: "translate(533.664 516.987)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_3",
    d: "M60.431 396.83h69.825V492H65.543c-.172.977-.337 1.961-.516 2.945h65.229V571.7c-.117-.034-.22-.076-.33-.117-1.844-.729-3.674-1.5-5.5-2.325l-1.17-.53q-2.752-1.3-5.5-2.752c-.64-.337-1.28-.688-1.913-1.046A114.5 114.5 0 0 1 88.4 543.49c-.234-.227-.454-.468-.688-.688-1.115-1.211-2.208-2.436-3.268-3.688l-1.17-1.376c-1.252-1.534-2.463-3.11-3.64-4.706-.172-.234-.337-.468-.516-.688a102.428 102.428 0 0 1-11.834-21.4c-.1-.227-.179-.475-.268-.688Q65.6 506.614 64.5 502.9c-.316-1.039-.619-2.064-.881-3.144-.1-.316-.179-.626-.255-.936C59.461 483.566 59 467.721 59 451.987v-5.5c0-6.364.076-12.769.186-19.168 0-1.658.069-3.309.1-4.974q.144-6.336.413-12.673c.041-1.176.1-2.346.158-3.516a19.912 19.912 0 0 1 .1-2.023c.171-2.453.309-4.881.474-7.303z",
    className: "prefix__cls-1",
    "data-name": "Path 3",
    transform: "translate(-50.759 -164.151)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_4",
    d: "M145.2 220.858h-38.3a290.341 290.341 0 0 1 20.372-28.043c5.69-6.99 11.7-13.8 17.929-20.365z",
    className: "prefix__cls-1",
    "data-name": "Path 4",
    transform: "translate(-65.704 -94.144)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5",
    d: "M131 247.09v100.076H61.4c0-.289.048-.585.069-.874.062-.791.124-1.582.193-2.367.076-.922.158-1.851.248-2.752s.186-2 .289-3 .2-2.009.316-3.007.22-2 .344-2.986.234-2 .365-2.986c.1-.826.213-1.644.323-2.47.158-1.163.323-2.332.5-3.488a3.218 3.218 0 0 1 .076-.516 237.974 237.974 0 0 1 5.127-25.12 185.814 185.814 0 0 1 8.634-25.456 191.094 191.094 0 0 1 12.989-25.016z",
    className: "prefix__cls-1",
    "data-name": "Path 5",
    transform: "translate(-51.508 -117.432)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6",
    d: "M186.8 291.3v95.178h149.137V291.3zm0 98.115v81.734c.853.179 1.7.351 2.539.5 1.142.22 2.277.42 3.44.592.22.034.447.069.688.089.454.076.922.138 1.376.2 1.149.158 2.291.289 3.44.392.544.055 1.094.1 1.644.145l1.328.1c.722.055 1.438.1 2.147.117.44 0 .881.041 1.335.055h4.905c.592 0 1.183 0 1.768-.055h.041a9.272 9.272 0 0 0 1.232-.055 2.888 2.888 0 0 0 .344 0 7.113 7.113 0 0 0 1.018-.048h.241l2.3-.179c.757-.069 1.52-.158 2.291-.241l1.569-.186a137.224 137.224 0 0 0 18.886-4.018c13.911-3.88 27.52-9.309 41.424-13.285 17.977-5.126 37.84-7.644 55.212-1.376v-64.479zm149.137-204.072V58.635a191.725 191.725 0 0 0-48.456 5.683c-37.764 9.487-71.648 30.065-100.682 56.347v64.672h7.485v2.938H186.8v100.09h149.137V188.281H225.018v-2.938zm191.559-42.8a61.774 61.774 0 0 1-27.031-7.857c-16.065-8.738-28.9-22.229-43.234-33.616-29.79-23.715-66.731-38.025-104.637-41.575v125.848h212.9l.53-.557zm19.395-3.44l20.564 22.566v-28.483c-6.887.853-12.921 2.883-20.537 5.889zm20.564 352.344v-102.03h-43.818c-.117-.433-.234-.874-.372-1.314.131.44.241.881.365 1.314H352.621V463.2c1.624 1.2 3.227 2.47 4.816 3.756 1.713 1.376 3.406 2.828 5.1 4.252l1.713 1.417c.819.688 1.644 1.376 2.477 2.023q2.477 2.009 5 3.963c.832.688 1.686 1.307 2.532 1.954a344.834 344.834 0 0 0 42.4 27.733q4.974 2.752 10.038 5.373c2.25 1.149 4.513 2.291 6.784 3.4q5.119 2.5 10.32 4.816a378.981 378.981 0 0 0 100.448 29.26q11.551 1.706 23.192 2.683v-62.39h.688zM352.621 188.281v100.083h214.862V188.281zm0 103.021v95.178h214.862V291.3zm231.539-158.24v31.772l26.247-28.8q-13.044-2.105-26.247-3.007zm0 158.274v95.143h208.979V291.3zM792.375 499l.736-109.584H584.16v165.513a374.762 374.762 0 0 0 40.385-.482h.234q9.632-.605 19.174-1.761h.145A353.108 353.108 0 0 0 742.62 526.4m90.816-219.423c-.784-1.851-1.6-3.688-2.436-5.5-1.555-3.44-3.2-6.784-4.892-10.127H809.8v95.136h41.225c-.021-26.942-6.839-54.462-17.572-79.539zM809.8 389.452v94.256a135.024 135.024 0 0 0 28.49-38.425c8.5-17.53 12.384-36.512 12.7-55.845zm0-125.849v24.768h14.778a268.326 268.326 0 0 0-14.758-24.8zM668.075 151.735c-1.087-.413-2.174-.832-3.268-1.238a298.322 298.322 0 0 0-35.3-10.609l-40.165 44.08-.771.819.516.564h142.951A305.755 305.755 0 0 0 668.1 151.7zm68.153 36.581H587.091L584.16 191v97.365h209.007V241.2a297.767 297.767 0 0 0-56.918-52.921z",
    className: "prefix__cls-1",
    "data-name": "Path 6",
    transform: "translate(-90.633 -58.63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_7",
    d: "M131 320.46v49.6H61.4c0-.289.048-.585.069-.874.062-.791.124-1.582.193-2.367.076-.922.158-1.851.248-2.752s.186-2 .289-3 .2-2.009.316-3.007.22-2 .344-2.986.234-2 .365-2.986c.1-.826.213-1.644.323-2.47.158-1.163.323-2.332.5-3.488a3.217 3.217 0 0 1 .076-.516 237.976 237.976 0 0 1 5.126-25.126z",
    className: "prefix__cls-1",
    "data-name": "Path 7",
    transform: "translate(-51.508 -140.324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_8",
    d: "M60.431 396.83h69.825V492H65.543c-.172.977-.337 1.961-.516 2.945h65.229V571.7c-.117-.034-.22-.076-.33-.117-1.844-.729-3.674-1.5-5.5-2.325l-1.17-.53q-2.752-1.3-5.5-2.752c-.64-.337-1.28-.688-1.913-1.046A114.5 114.5 0 0 1 88.4 543.49c-.234-.227-.454-.468-.688-.688-1.115-1.211-2.208-2.436-3.268-3.688l-1.17-1.376c-1.252-1.534-2.463-3.11-3.64-4.706-.172-.234-.337-.468-.516-.688a102.428 102.428 0 0 1-11.834-21.4c-.1-.227-.179-.475-.268-.688Q65.6 506.614 64.5 502.9c-.316-1.039-.619-2.064-.881-3.144-.1-.316-.179-.626-.255-.936C59.461 483.566 59 467.721 59 451.987v-5.5c0-6.364.076-12.769.186-19.168 0-1.658.069-3.309.1-4.974q.144-6.336.413-12.673c.041-1.176.1-2.346.158-3.516a19.912 19.912 0 0 1 .1-2.023c.171-2.453.309-4.881.474-7.303z",
    className: "prefix__cls-1",
    "data-name": "Path 8",
    transform: "translate(-50.759 -164.151)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_9",
    d: "M192.061 196.113v85.752h-52.5v-85.752h7.485V167.08h30.726v29.033z",
    className: "prefix__cls-1",
    "data-name": "Path 9",
    transform: "translate(-43.393 -52.131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_25",
    d: "M0 0H52.494V95.171H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 25",
    transform: "translate(96.174 232.672)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_10",
    d: "M186.8 539.44h52.5v79.12a136.992 136.992 0 0 1-18.886 4.011l-1.569.193c-.771.089-1.534.165-2.291.241s-1.541.131-2.3.179h-.241c-.33 0-.688.041-1.011.048h-.351c-.413 0-.826.041-1.238.055-.585.034-1.17.041-1.768.048h-4.875l-1.328-.048c-.688 0-1.431-.076-2.147-.124l-1.321-.1-1.644-.151c-1.156-.1-2.3-.234-3.44-.392l-1.376-.193-.688-.1c-1.149-.179-2.284-.371-3.44-.592-.846-.144-1.686-.323-2.539-.5z",
    className: "prefix__cls-1",
    "data-name": "Path 10",
    transform: "translate(-90.633 -208.646)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_26",
    d: "M0 0H43.289V95.872H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 26",
    transform: "translate(433.561 133.855)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_11",
    d: "M595.449 338.19v95.178H380.58v-41.053h114.448v24.218h57.124V338.19z",
    className: "prefix__cls-1",
    "data-name": "Path 11",
    transform: "translate(-118.592 -105.518)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_12",
    d: "M643.37 640.888h-.688v62.436q-11.627-.984-23.186-2.676a379 379 0 0 1-100.489-29.323q-13.849-6.233-27.135-13.609a346.253 346.253 0 0 1-42.408-27.733q-5.064-3.88-10-7.939c-2.277-1.878-4.541-3.8-6.832-5.676-1.589-1.287-3.192-2.552-4.816-3.763v-73.76h171c-.117-.44-.234-.881-.358-1.314.131.433.255.874.372 1.314h43.846v102c.24.009.467.029.694.043z",
    className: "prefix__cls-1",
    "data-name": "Path 12",
    transform: "translate(-165.832 -208.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_13",
    d: "M891.428 226.995H863.22v-8.765h12.645v-26.11q1.644.6 3.275 1.232v24.878h12.288z",
    className: "prefix__cls-1",
    "data-name": "Path 13",
    transform: "translate(-301.678 -100.281)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_14",
    d: "M928.544 347.166h-138.48l.048.034-.062-.034h-25.69v-95.872h7.279v70.864H804.9V280.19h27.479v-33.1h28.211v33.127h27.479v41.968h40.475z",
    className: "prefix__cls-1",
    "data-name": "Path 14",
    transform: "translate(-270.833 -117.432)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_15",
    d: "M764.36 396.82V492h164.184v-95.18zm208.752 207.211l.227-75.336h-44.8v-33.712H764.36v165.464a374.747 374.747 0 0 0 40.385-.482h.234q9.632-.606 19.174-1.761h.145a353.106 353.106 0 0 0 98.521-26.288",
    className: "prefix__cls-1",
    "data-name": "Path 15",
    transform: "translate(-270.833 -164.148)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_16",
    d: "M1095.26 539.44h38.3c-.337 19.326-4.217 38.308-12.707 55.838a135.067 135.067 0 0 1-28.483 38.422v-60.541h2.89z",
    className: "prefix__cls-1",
    "data-name": "Path 16",
    transform: "translate(-373.173 -208.646)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_17",
    d: "M1134.891 499.089h-38.321V419.55h20.736c10.733 25.078 17.551 52.597 17.585 79.539z",
    className: "prefix__cls-1",
    "data-name": "Path 17",
    transform: "translate(-374.484 -171.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_27",
    d: "M0 0H23.192V30.059H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 27",
    transform: "translate(453.664 160.508)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_28",
    d: "M0 0H23.192V6.921H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 28",
    transform: "translate(453.664 222.813)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_29",
    d: "M0 0H23.192V20.193H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 29",
    transform: "translate(453.664 232.672)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_30",
    d: "M0 0H23.192V30.059H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 30",
    transform: "translate(453.664 285.118)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_31",
    d: "M0 0H23.192V30.059H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 31",
    transform: "translate(453.664 347.423)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_18",
    d: "M729.606 677.239a3.814 3.814 0 0 1 .688.041h-.688v6.983H706.42V654.17h23.186z",
    className: "prefix__cls-1",
    "data-name": "Path 18",
    transform: "translate(-252.756 -244.442)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_19",
    d: "M729.606 744.71v23.22q-11.627-.984-23.186-2.676V744.71z",
    className: "prefix__cls-1",
    "data-name": "Path 19",
    transform: "translate(-252.756 -272.691)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_32",
    d: "M0 0H99.395V2.208H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 32",
    transform: "translate(261.988 325.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_33",
    d: "M0 0H99.395V8.462H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 33",
    transform: "translate(261.988 330.787)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_34",
    d: "M0 0H99.395V13.609H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 34",
    transform: "translate(261.988 366.99)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_20",
    d: "M529.389 652.15v13.609h-77.744q-5.064-3.867-10-7.94c-2.277-1.878-4.534-3.8-6.832-5.669z",
    className: "prefix__cls-1",
    "data-name": "Path 20",
    transform: "translate(-168.013 -243.812)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_21",
    d: "M556.256 712.231v13.595h-8.208q-13.836-6.24-27.128-13.615z",
    className: "prefix__cls-1",
    "data-name": "Path 21",
    transform: "translate(-194.88 -262.551)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_35",
    d: "M0 0H19.567V19.567H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 35",
    transform: "translate(533.919 241.898)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_36",
    d: "M0 0H19.567V19.567H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 36",
    transform: "translate(110.264 150.731)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_37",
    d: "M0 0H19.567V19.567H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 37",
    transform: "translate(110.264 196.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_38",
    d: "M0 0H19.567V19.567H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 38",
    transform: "translate(110.264 241.63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_39",
    d: "M0 0H19.567V19.567H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 39",
    transform: "translate(110.264 287.072)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_40",
    d: "M0 0H19.567V19.567H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 40",
    transform: "translate(110.264 332.521)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_41",
    d: "M0 0H19.567V19.567H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 41",
    transform: "translate(110.264 377.97)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_42",
    d: "M0 0H19.567V19.567H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 42",
    transform: "translate(608.615 241.898)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_43",
    d: "M0 0H19.567V19.567H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 43",
    transform: "translate(533.919 290.161)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_44",
    d: "M0 0H19.567V19.567H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 44",
    transform: "translate(608.615 290.161)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_45",
    d: "M0 0H19.567V19.567H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 45",
    transform: "translate(533.919 338.417)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_46",
    d: "M0 0H19.567V19.567H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 46",
    transform: "translate(608.615 338.417)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_47",
    d: "M0 0H19.567V19.567H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 47",
    transform: "translate(533.919 386.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_48",
    d: "M0 0H19.567V19.567H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 48",
    transform: "translate(608.615 386.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_49",
    d: "M0 0H19.567V19.567H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 49",
    transform: "translate(533.919 434.943)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_50",
    d: "M0 0H19.567V19.567H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 50",
    transform: "translate(608.615 434.943)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_22",
    d: "M775.83 714.948V702.33h19.56v10.822z",
    className: "prefix__cls-1",
    "data-name": "Path 22",
    transform: "translate(-241.911 -219.131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_23",
    d: "M65.24 357v11.194h66.96V357zm6.674 10.492h-5.463v-9.8h5.5zm6.667 0h-5.5v-9.8h5.5zm6.653 0h-5.5v-9.8h5.5zm6.667 0H86.4v-9.8h5.5zm6.66 0h-5.5v-9.8h5.5zm6.667 0h-5.5v-9.8h5.5zm6.667 0h-5.5v-9.8h5.5zm6.66 0h-5.5v-9.8h5.5zm6.66 0h-5.5v-9.8h5.5zm6.66 0h-5.5v-9.8h5.5z",
    className: "prefix__cls-1",
    "data-name": "Path 23",
    transform: "translate(-52.706 -151.724)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_24",
    d: "M65.24 404.34v11.194h66.96V404.34zm6.674 10.485h-5.463v-9.776h5.5zm6.667 0h-5.5v-9.776h5.5zm6.653 0h-5.5v-9.776h5.5zm6.667 0H86.4v-9.776h5.5zm6.66 0h-5.5v-9.776h5.5zm6.667 0h-5.5v-9.776h5.5zm6.667 0h-5.5v-9.776h5.5zm6.66 0h-5.5v-9.776h5.5zm6.66 0h-5.5v-9.776h5.5zm6.66 0h-5.5v-9.776h5.5z",
    className: "prefix__cls-1",
    "data-name": "Path 24",
    transform: "translate(-52.706 -166.494)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_25",
    d: "M65.24 451.7v11.214h66.96V451.7zm6.674 10.485h-5.463V452.4h5.5zm6.667 0h-5.5V452.4h5.5zm6.653 0h-5.5V452.4h5.5zm6.667 0H86.4V452.4h5.5zm6.66 0h-5.5V452.4h5.5zm6.667 0h-5.5V452.4h5.5zm6.667 0h-5.5V452.4h5.5zm6.66 0h-5.5V452.4h5.5zm6.66 0h-5.5V452.4h5.5zm6.66 0h-5.5V452.4h5.5z",
    className: "prefix__cls-1",
    "data-name": "Path 25",
    transform: "translate(-52.706 -181.271)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_26",
    d: "M65.24 499.06v11.18h66.96v-11.18zm6.674 10.485h-5.463v-9.79h5.5zm6.667 0h-5.5v-9.79h5.5zm6.653 0h-5.5v-9.79h5.5zm6.667 0H86.4v-9.79h5.5zm6.66 0h-5.5v-9.79h5.5zm6.667 0h-5.5v-9.79h5.5zm6.667 0h-5.5v-9.79h5.5zm6.66 0h-5.5v-9.79h5.5zm6.66 0h-5.5v-9.79h5.5zm6.66 0h-5.5v-9.79h5.5z",
    className: "prefix__cls-1",
    "data-name": "Path 26",
    transform: "translate(-52.706 -196.047)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_27",
    d: "M65.66 546.41c.268 1.053.571 2.105.888 3.144v-2.442h5.5v9.788h-2.941c.089.227.179.475.268.688h62.959V546.41zm13.072 10.49h-5.5v-9.783h5.5zm6.653 0h-5.5v-9.783h5.5zm6.667 0h-5.518v-9.783h5.5zm6.66 0h-5.5v-9.783h5.5zm6.667 0h-5.5v-9.783h5.5zm6.667 0h-5.5v-9.783h5.5zm6.66 0h-5.5v-9.783h5.5zm6.66 0h-5.5v-9.783h5.5zm6.66 0h-5.5v-9.783h5.5z",
    className: "prefix__cls-1",
    "data-name": "Path 27",
    transform: "translate(-52.837 -210.821)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_28",
    d: "M88.26 593.77c.172.22.337.468.516.688h3.64v4.7c.392.468.777.936 1.176 1.376v-6.1h5.5v9.818h-2.225c.22.227.433.468.688.688h41.851v-11.17zm17.482 10.478h-5.5v-9.776h5.5zm6.667 0h-5.5v-9.776h5.5zm6.667 0h-5.5v-9.776h5.5zm6.66 0h-5.5v-9.776h5.5zm6.66 0h-5.5v-9.776h5.5zm6.66 0h-5.5v-9.776h5.5z",
    className: "prefix__cls-1",
    "data-name": "Path 28",
    transform: "translate(-59.889 -225.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_29",
    d: "M141.65 641.12c.626.358 1.266.688 1.913 1.046v-.344h5.5v3.1l1.17.543v-3.639h5.5v5.951a1.724 1.724 0 0 0 .33.124v-6.781z",
    className: "prefix__cls-1",
    "data-name": "Path 29",
    transform: "translate(-76.546 -240.37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_30",
    d: "M613.271 345.821zM570.89 548.877zM526.672 445.56c.131.44.241.881.365 1.314-.11-.433-.227-.874-.365-1.314zm86.6-99.76zM197.72 242.78v2.938h30.733v-2.938zm373.17 306.1zm-44.218-103.32c.131.44.241.881.365 1.314-.11-.433-.227-.874-.365-1.314zm86.6-99.76zM570.89 548.856zm-44.218-103.3c.131.44.241.881.365 1.314-.11-.429-.227-.87-.365-1.31z",
    className: "prefix__cls-1",
    "data-name": "Path 30",
    transform: "translate(-94.04 -116.087)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_31",
    fill: "url(#prefix__linear-gradient)",
    d: "M442.315 369.615s-2.711-.378-2.711-4.327-1.94-11.324-1.94-11.324c0-.034-1.679-12.845-4-14.881s-5.3-13.994-5.3-13.994-.509-6.488-1.548-7.884-2.442-4.816-4.513-9.694-10.705-8.256-10.705-8.256-15.611-9.054-20.034-12.006a6.786 6.786 0 0 1-1.121-.846c-.771-1.011-4.128-1.032-4.128-1.032a67.64 67.64 0 0 1-.8-7.066 5.374 5.374 0 0 0-.034-.743 23.8 23.8 0 0 0 10.464-12.948c.083-.261.151-.537.227-.8a2.236 2.236 0 0 0 1.342-1.211 25.242 25.242 0 0 1 .9-2.752 10.365 10.365 0 0 1 2.546-2.236c2.188-1.858 2.752-4.988 2.649-7.836-.069-2.3-.44-4.63-.3-6.921l.041-.578c.041-.344.089-.688.151-1.018.337-1.706 1.073-3.316 1.486-5.009a6.443 6.443 0 0 0-.509-5.057c-1.41-2.14-4.348-2.566-6.928-2.786-2.924-.248-5.538.076-7.41-2.353a26.413 26.413 0 0 0-2.945-3.557c-.385-.358-4.128-2.642-4.128-2.793a16.725 16.725 0 0 0-11.662-.894c-1.94.564-3.77 1.486-5.738 1.947-4.245 1-9.13-.083-12.735 2.346-2.009 1.376-3.213 3.564-4.341 5.7q-1.376 2.635-2.793 5.263a34.1 34.1 0 0 0-3.708 9.006 14.293 14.293 0 0 0-.248 2.105v1.12a3.7 3.7 0 0 0 .041.688c.041.213.034.282.055.427s.055.468.1.688.124.605.206.908c.034.131.083.255.124.378.069.234.151.461.241.688.048.117.1.241.151.358a6.436 6.436 0 0 0 .351.688c.055.1.1.186.151.275a9.128 9.128 0 0 0 .633.922c1.472 1.837 3.639 3.007 5.243 4.727v.771a23.55 23.55 0 0 0 10.719 19.23c0 .261.034.53.048.791a39.374 39.374 0 0 1-.076 6.13 2.89 2.89 0 0 0-2.284-1.018 3.3 3.3 0 0 0-.881.076l-.062-.048v.062c-1.514.372-3.378 1.947-5.16 6.426 0 0-5.421 6.109-9.549 5.855s-14.579 6.357-14.579 6.357-10.2 6.619-12.384 13.361a94.151 94.151 0 0 1-4.389 11.2l-12.6 25.972-2.325 20.606s1.287 9.164 1.032 10.561 5.291 13.994 5.291 13.994 18.321 32.191 25.807 33.843l.537-.378a4.39 4.39 0 0 0 1.011.378l1.541-1.087a16.793 16.793 0 0 1-.117 3.633c-1.032 3.179.385 23.922 2.188 27.988s1.163 57.379 1.163 57.379l-.255 4.706a2 2 0 0 0 .062.413l-.062 1.115.186.1a13.25 13.25 0 0 1-.186 4.479c-.647 2.064-.908 7.9-.908 7.9s-5.153 32.941-2.711 39.56 4.52 13.87 4.52 13.87 2.58 8.256.124 9.666-9.439 3.777-8 7.217c1.307 3.179 6.268 11.7 7 12.941l-.062.654-1.011 10.96a13.761 13.761 0 0 0 1.163 4.183c1.108 2.387 3.261 4.864 7.355 4.6.688-.048 1.486-.131 2.257-.234a97.522 97.522 0 0 0 16.718-4.348 6.818 6.818 0 0 1-1.307-1.08 3.777 3.777 0 0 1-1.149-2.752c.11-2-3.626-11.5-4.555-13.843-.144-.337-.22-.53-.22-.53s8.517-8.9 7.1-16.794c0 0-9.426-5.5-6.323-8.524s8.648-11.7 8.648-11.7.255-32.439 0-37.283a40.111 40.111 0 0 1 .475-10.065c.1-.5.227-.991.358-1.472a89.807 89.807 0 0 0 12.962.984c1.582 0 3.192 0 4.816-.1q0 .688.062 1.486c.358 8.036 1.025 22.126 1.569 27.362.771 7.506 5.029 27.733 5.029 27.733s-8.125 5.215 1.417 18.067c0 0 0 4.658-.633 5.332a58.318 58.318 0 0 0-1.631 6.715c-.4 2.422-.564 4.871.083 6.144 1.548 3.041 10.836 2.793 10.836 2.793l.227-.041a13.313 13.313 0 0 1 9.831 2.965c3.529 2.835 16.925 1.589 24.176.688 2.841-.358 4.74-.688 4.74-.688a2.752 2.752 0 0 0 .1-.991c-.076-1.782-1.472-5.69-10.939-9.178 0 0-8.9-5.986-8.779-11.2h-1.218a9.709 9.709 0 0 1 1.232 0s-3.488-12.728-2.064-13.76-2.841-15.136-2.841-15.136-2.442-23.667-2.573-25.325a14.45 14.45 0 0 1 .64-4.2l-.64-12.976s-.124-4.314 0-5.717a28.553 28.553 0 0 0-.3-3.64c-.062-.482-.124-.984-.193-1.479 3.337-.846 5.5-1.631 5.5-1.631l-.375-45.175c2.835-5.5 3.357-17.578 3.344-26.144 0-5.5-.248-9.577-.248-9.577l3.873-6.323s.894-7.568-.523-9.226a1.588 1.588 0 0 1 .172-2.167 7.2 7.2 0 0 1 .846-.578s-.041-.062-.089-.151a6.836 6.836 0 0 1 .86-.612s-1.376-2.133-.144-3.034c1.156.784 2.188 1.376 2.972 1.858-.055.5-.11.791-.11.791l.33-.688 1.218.688s6.068-12.088 5.937-13.87 4.128-9.288 4.128-9.288.516-3.942 2.841-5.593 1.8-13.615 1.8-13.615.647-6.233 2.195-8.779-1.407-5.977-1.407-5.977zm-116.106-5.3l.117 2.883-1.183-1.906z",
    "data-name": "Path 31",
    transform: "translate(-124.585 -108.405)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_32",
    d: "M479.537 505.525l-1.486 6.33S466.149 505.78 464 498.06s3.591-10.65 3.591-10.65l11.091 4.7z",
    className: "prefix__cls-3",
    "data-name": "Path 32",
    transform: "translate(-176.971 -192.412)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_33",
    d: "M479.537 505.525l-1.486 6.33S466.149 505.78 464 498.06s3.591-10.65 3.591-10.65l11.091 4.7z",
    className: "prefix__cls-4",
    "data-name": "Path 33",
    transform: "translate(-176.971 -192.412)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_34",
    d: "M377.5 815.484s-11.008 4.045-18.576 4.555c-4.018.268-6.13-2.195-7.217-4.568a13.829 13.829 0 0 1-1.135-4.162l.984-10.9.523-5.807 16.078-4.176 2.277 6.963.213.53c.915 2.325 4.582 11.785 4.472 13.76a3.756 3.756 0 0 0 1.128 2.718 6.544 6.544 0 0 0 1.252 1.094z",
    className: "prefix__cls-3",
    "data-name": "Path 34",
    transform: "translate(-141.73 -286.952)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_35",
    d: "M476.59 809.611a2.752 2.752 0 0 1-.1.984s-23.543 3.929-28.359 0a12.755 12.755 0 0 0-9.907-2.9s-9.109.248-10.63-2.752c-.633-1.259-.468-3.7-.076-6.109a58.215 58.215 0 0 1 1.6-6.68l.365-.289 2.167-1.741 25.373-.75h.193c-.124 5.188 8.614 11.139 8.614 11.139 9.281 3.436 10.65 7.323 10.76 9.098z",
    className: "prefix__cls-3",
    "data-name": "Path 35",
    transform: "translate(-165.631 -286.625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_36",
    d: "M476.592 813.9a2.807 2.807 0 0 1-.1.984s-23.536 3.929-28.352 0a12.755 12.755 0 0 0-9.9-2.9s-9.116.248-10.63-2.752c-.633-1.266-.475-3.7-.083-6.109 3.509.351 9.047 1.225 11.221 3.309 3.289 3.172 8.861 6.336 12.281 6.584 2.671.169 18.683.679 25.563.884z",
    className: "prefix__cls-4",
    "data-name": "Path 36",
    transform: "translate(-165.633 -290.915)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_37",
    d: "M378.016 826.37s-11.008 4.045-18.576 4.555c-4.018.268-6.13-2.195-7.21-4.575 2.8.943 6.687 1.933 8.731 1.025 2.422-1.073 11.008-1.768 15.824-2.064a6.775 6.775 0 0 0 1.231 1.059z",
    className: "prefix__cls-4",
    "data-name": "Path 37",
    transform: "translate(-142.248 -297.838)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_38",
    d: "M405.15 334.28c-9.082-3.529-20.764-15.191-17.847-20.64a12.192 12.192 0 0 0 1.135-4.376 39.952 39.952 0 0 0 .083-6.192A84.8 84.8 0 0 0 387.3 293s28.352.64 26.7 4.816a15.614 15.614 0 0 0-.427 5.731c.131 2.38.475 5.071.832 7.348.5 3.124.991 5.5.991 5.5s-1.734 2.429-2.752 2.559 5.537 20.355-7.494 15.326z",
    className: "prefix__cls-5",
    "data-name": "Path 38",
    transform: "translate(-153.049 -131.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_39",
    d: "M371.062 797.912l-.213.234c-8.476-10.251-18.727 2.525-18.727 2.525l-.151-.268.523-5.807 16.078-4.176 2.277 6.963z",
    className: "prefix__cls-4",
    "data-name": "Path 39",
    transform: "translate(-142.167 -286.952)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_40",
    d: "M458.111 790.08s-6.192-.131-9.494 2.786-19.264.633-18.576 0a2.264 2.264 0 0 0 .358-1.046l2.167-1.741 25.373-.75c.096.462.172.751.172.751z",
    className: "prefix__cls-4",
    "data-name": "Path 40",
    transform: "translate(-166.518 -286.612)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_41",
    d: "M378.433 667.248a19.142 19.142 0 0 0-1.046 3.529 40.39 40.39 0 0 0-.475 10.017c.255 4.816 0 37.09 0 37.09s-5.442 8.607-8.476 11.641 6.192 8.483 6.192 8.483c1.376 7.843-6.963 16.7-6.963 16.7-8.476-10.251-18.727 2.532-18.727 2.532s-5.573-9.632-6.963-13.072 5.442-5.821 7.843-7.217-.117-9.632-.117-9.632-2.03-7.217-4.438-13.8 2.656-39.36 2.656-39.36.261-5.821.888-7.85a13.126 13.126 0 0 0 .186-4.458c-.041-.5-.089-.922-.124-1.2s-.062-.413-.062-.413l.1-.165 3.44-6.412s27.737 9.548 26.086 13.587z",
    className: "prefix__cls-6",
    "data-name": "Path 41",
    transform: "translate(-138.991 -244.283)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_42",
    d: "M454.738 750.045s-6.192-.131-9.494 2.752-19.264.633-18.576 0 .633-5.318.633-5.318c-9.364-12.783-1.376-17.97-1.376-17.97s-4.183-20.124-4.94-27.589c-.53-5.215-1.183-19.23-1.534-27.231-.151-3.44-.241-5.807-.241-5.807l7.651-1.541.984-.2 18.452-3.7s.509 3.44.853 6.254a29.235 29.235 0 0 1 .289 3.626c-.124 1.376 0 5.683 0 5.683l.626 12.914a14.667 14.667 0 0 0-.626 4.176c.124 1.644 2.525 25.188 2.525 25.188s4.176 14.049 2.752 15.06 2.022 13.703 2.022 13.703z",
    className: "prefix__cls-6",
    "data-name": "Path 42",
    transform: "translate(-163.146 -247.334)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_43",
    d: "M414.211 297.816a15.613 15.613 0 0 0-.427 5.731 23.564 23.564 0 0 1-25.057-.468A84.8 84.8 0 0 0 387.51 293s28.352.626 26.701 4.816z",
    className: "prefix__cls-4",
    "data-name": "Path 43",
    transform: "translate(-153.255 -131.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_44",
    d: "M420.9 267.223a23.3 23.3 0 0 1-1.156 7.3 23.543 23.543 0 0 1-45.917-6.736v-.564a23.542 23.542 0 1 1 47.083 0z",
    className: "prefix__cls-5",
    "data-name": "Path 44",
    transform: "translate(-148.987 -116.368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_45",
    d: "M405.15 341.656c-9.082-3.529-20.764-15.191-17.847-20.64a12.192 12.192 0 0 0 1.135-4.376l12.432 10.217 7.692 6.309 5.848-14.888c.5 3.124.991 5.5.991 5.5s-1.734 2.429-2.752 2.559 5.532 20.348-7.499 15.319z",
    className: "prefix__cls-4",
    "data-name": "Path 45",
    transform: "translate(-153.049 -139.132)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_46",
    d: "M386.192 327.683L375.81 502.09l-13.54.888-35.06-101.129 5.752-120.062 1.211-25.366 15.59 12.8 7.7 6.309 6.02-15.322 11.194 9.756z",
    className: "prefix__cls-6",
    "data-name": "Path 46",
    transform: "translate(-101.941 -80.006)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_47",
    d: "M381.618 667.273a19.142 19.142 0 0 0-1.046 3.529 99.76 99.76 0 0 1-28.387-8.868l-.186-.1.062-1.108.034-.578 3.44-6.412s27.735 9.498 26.083 13.537z",
    className: "prefix__cls-4",
    "data-name": "Path 47",
    transform: "translate(-142.176 -244.308)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_48",
    d: "M427 675.641a69.679 69.679 0 0 1-7.609.867c-.151-3.44-.241-5.807-.241-5.807l7.651-1.541z",
    className: "prefix__cls-4",
    "data-name": "Path 48",
    transform: "translate(-163.127 -249.119)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_49",
    d: "M451.005 669.744c-4.892 1.273-12.446 2.7-19.209 1.809l-.1-4.362 18.452-3.7s.513 3.409.857 6.253z",
    className: "prefix__cls-4",
    "data-name": "Path 49",
    transform: "translate(-167.043 -247.35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_50",
    d: "M391.206 563.623c-28.208 4.816-54.042-8.992-54.042-8.992l.248-4.678s.64-53.038-1.135-57.1-3.158-24.685-2.153-27.85-3.667-50.623-3.667-50.623l-.757-19.264L302 383.89l12.384-25.814a93.155 93.155 0 0 0 4.307-11.146c2.153-6.7 12.15-13.285 12.15-13.285s10.251-6.577 14.3-6.33 9.364-5.82 9.364-5.82c3.922-10 7.472-5.47 7.472-5.47a8.931 8.931 0 0 1-.193 1.479c-1.376 10.974 22.25 45.649 22.587 46.261l2.25 54.806 2.277 69.357z",
    className: "prefix__cls-4",
    "data-name": "Path 50",
    transform: "translate(-126.576 -138.621)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_51",
    d: "M390.1 563.6c-28.208 4.816-54.049-8.992-54.049-8.992l.255-4.678s.64-53.038-1.142-57.1-3.158-24.685-2.147-27.85-3.667-50.623-3.667-50.623l-.764-19.264-27.716-11.263 12.384-25.814a94.6 94.6 0 0 0 4.307-11.146c2.147-6.7 12.15-13.285 12.15-13.285s10.251-6.577 14.3-6.33 9.364-5.82 9.364-5.82c3.928-10 8.256-5.47 8.256-5.47 0 .475-.413.688-.193 1.479 3.027 10.643 21.493 45.649 21.83 46.261l2.277 54.806 2.277 69.357z",
    className: "prefix__cls-3",
    "data-name": "Path 51",
    transform: "translate(-126.223 -138.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_52",
    d: "M407.726 365.991c-3.034-1.266-19.106-19.615-19.106-19.615V342.2c-.585-1.376-4.059-.537-6.88.427l1.211-25.366 1.376 1.142c3.013 10.636 23.048 46.976 23.399 47.588z",
    className: "prefix__cls-4",
    "data-name": "Path 52",
    transform: "translate(-151.455 -139.325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_53",
    d: "M408.833 363.781c-3.041-1.266-19.113-19.615-19.113-19.615v-4.176c-.585-1.376-4.059-.537-6.88.427l1.218-25.366 1.376 1.142c3.02 10.636 23.066 46.982 23.399 47.588z",
    className: "prefix__cls-3",
    "data-name": "Path 53",
    transform: "translate(-151.798 -138.636)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_54",
    d: "M352.408 517.973c.378 0 19.615-2.023 19.615-2.023s11.648 22.9 10.884 28.476-2.147 10.506-6.832 9.632-25.215.688-25.215.688z",
    className: "prefix__cls-4",
    "data-name": "Path 54",
    transform: "translate(-141.82 -201.317)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_55",
    d: "M351.3 515.763c.378 0 19.615-2.023 19.615-2.023s11.641 22.91 10.884 28.476-2.153 10.506-6.832 9.632-25.215.688-25.215.688z",
    className: "prefix__cls-3",
    "data-name": "Path 55",
    transform: "translate(-141.474 -200.627)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_56",
    d: "M368.3 501.05s17.654 9.487 18.032 12.384-8.985-1.266-11.008-1.768a25.192 25.192 0 0 0-4.052-.633l-13.492.365z",
    className: "prefix__cls-5",
    "data-name": "Path 56",
    transform: "translate(-143.979 -196.668)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_11",
    cx: 1.858,
    cy: 1.858,
    r: 1.858,
    className: "prefix__cls-4",
    "data-name": "Ellipse 11",
    transform: "translate(249.487 224.134)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_12",
    cx: 1.858,
    cy: 1.858,
    r: 1.858,
    className: "prefix__cls-7",
    "data-name": "Ellipse 12",
    transform: "translate(249.487 223.377)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_13",
    cx: 1.858,
    cy: 1.858,
    r: 1.858,
    className: "prefix__cls-4",
    "data-name": "Ellipse 13",
    transform: "translate(252.906 304.547)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_14",
    cx: 1.858,
    cy: 1.858,
    r: 1.858,
    className: "prefix__cls-7",
    "data-name": "Ellipse 14",
    transform: "translate(252.906 303.783)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_15",
    cx: 1.858,
    cy: 1.858,
    r: 1.858,
    className: "prefix__cls-4",
    "data-name": "Ellipse 15",
    transform: "translate(251.338 264.34)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_16",
    cx: 1.858,
    cy: 1.858,
    r: 1.858,
    className: "prefix__cls-7",
    "data-name": "Ellipse 16",
    transform: "translate(251.338 263.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_57",
    d: "M461.561 453.8s1.266 1.9 0 2.786.124 3.034.124 3.034-3.158 1.851-1.768 3.516.509 9.185.509 9.185l-3.8 6.288s.227 4.052.241 9.529c0 8.545-.5 20.557-3.282 26.034l.385 44.933s-13.3 4.857-24.431 3.378l-1.651-72.1s2.408-40.888 3.3-48.731a81.653 81.653 0 0 0 .633-12.281s-.378-12.274-1.651-17.971c0 0-1.376-24.678-1.514-31.51-.062-3.268.11-12.8.3-21.871.213-9.914.454-19.264.454-19.264l-2.51-19.868s2.511-.255 3.268.757a7.242 7.242 0 0 0 1.1.846c4.334 2.931 19.649 11.944 19.649 11.944s8.476 3.371 10.506 8.2 3.44 8.256 4.424 9.632 1.52 7.843 1.52 7.843 2.917 11.9 5.194 13.918 3.942 14.84 3.942 14.84l-20.124 15.824s-1.768 26.323-2.147 27.341 7.329 23.768 7.329 23.768z",
    className: "prefix__cls-3",
    "data-name": "Path 57",
    transform: "translate(-165.545 -139.824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_58",
    d: "M462.3 453.7s1.259 1.9 0 2.786.117 3.034.117 3.034-3.137 1.871-1.761 3.536.509 9.185.509 9.185l-3.8 6.288s.227 4.052.248 9.529c0 8.545-.5 20.557-3.282 26.034l.378 44.933s-13.32 4.857-24.438 3.378l-1.644-72.1s2.408-40.888 3.3-48.731a80.894 80.894 0 0 0 .626-12.281s-.378-12.274-1.644-17.97c0 0-1.376-24.678-1.52-31.51-.062-3.268.117-12.8.3-21.871.213-9.914.454-19.264.454-19.264l-3.313-20.136s3.316 0 4.08 1.025a6.528 6.528 0 0 0 1.1.846c4.334 2.931 19.656 11.944 19.656 11.944s8.469 3.371 10.5 8.2 3.44 8.256 4.431 9.632 1.514 7.843 1.514 7.843 2.917 11.9 5.194 13.918 3.922 14.813 3.922 14.813L457.1 402.586s-1.768 26.323-2.153 27.341S462.3 453.7 462.3 453.7z",
    className: "prefix__cls-3",
    "data-name": "Path 58",
    transform: "translate(-165.523 -139.725)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_59",
    d: "M438.549 345.2l1.816 5.3-9.563 9.632c.213-9.907.454-19.264.454-19.264l-3.316-20.138s3.316 0 4.08 1.025a6.276 6.276 0 0 0 1.1.839l8.132 23.461z",
    className: "prefix__cls-4",
    "data-name": "Path 59",
    transform: "translate(-165.87 -140.408)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_60",
    d: "M437.439 342.992l1.823 5.3-9.563 9.632c.213-9.914.454-19.264.454-19.264l-3.323-20.14s3.323 0 4.08 1.025a6.88 6.88 0 0 0 1.1.846l8.139 23.454z",
    className: "prefix__cls-3",
    "data-name": "Path 60",
    transform: "translate(-165.523 -139.718)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_61",
    d: "M420.9 267.223a23.3 23.3 0 0 1-1.156 7.3.984.984 0 0 1-.743-.186c-.179-6.192-3.227-12.006-6.976-16.952a17.811 17.811 0 0 0-3.784-3.922 7.4 7.4 0 0 0-5.132-1.452c-2.064.282-3.887 1.686-5.972 1.864-2.752.227-5.215-1.679-7.946-1.775a7.809 7.809 0 0 0-5.841 2.711 16.023 16.023 0 0 0-3.13 5.807 33.974 33.974 0 0 0-1.747 10.017c-.034 1.926-.22 4.341-2.009 5.043a10.279 10.279 0 0 0-2.594-7.85l-.041-.041v-.564a23.542 23.542 0 1 1 47.083 0z",
    className: "prefix__cls-4",
    "data-name": "Path 61",
    transform: "translate(-148.987 -116.368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_62",
    fill: "#512e4e",
    d: "M403.854 222.871a16.209 16.209 0 0 0-11.435-.894c-1.906.564-3.7 1.479-5.635 1.94-4.128 1-8.944-.083-12.487 2.332-1.968 1.376-3.151 3.55-4.252 5.662l-2.752 5.243a34.021 34.021 0 0 0-3.64 8.944c-.626 3.158-.248 6.694 1.754 9.233 1.459 1.851 3.612 3.013 5.194 4.754a10.32 10.32 0 0 1 2.587 7.843c1.8-.688 1.968-3.11 2.009-5.036a33.974 33.974 0 0 1 1.747-10.017 15.969 15.969 0 0 1 3.13-5.807 7.823 7.823 0 0 1 5.841-2.711c2.752.1 5.222 2 7.946 1.768 2.064-.172 3.894-1.582 5.972-1.858a7.375 7.375 0 0 1 5.133 1.452 17.626 17.626 0 0 1 3.777 3.922c3.756 4.947 6.8 10.747 6.983 16.952.777.571 1.9-.172 2.284-1.053a25.152 25.152 0 0 1 .888-2.752 10.148 10.148 0 0 1 2.491-2.215c2.147-1.851 2.683-4.967 2.6-7.8s-.633-5.7-.1-8.476c.323-1.706 1.053-3.3 1.452-4.988a6.522 6.522 0 0 0-.5-5.029c-1.376-2.133-4.272-2.552-6.8-2.752-2.869-.248-5.435.069-7.265-2.346a26.351 26.351 0 0 0-2.89-3.536c-.351-.353-4.032-2.624-4.032-2.775z",
    "data-name": "Path 62",
    transform: "translate(-145.726 -109.394)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_63",
    d: "M309.227 428.422l-7.19-13.292-2.277 20.509s1.266 9.109 1.011 10.506 5.188 13.918 5.188 13.918 17.977 32.019 25.318 33.671l24.8-17.723-6.577-8.352s-2.277-.888-2.848 0c0 0-12.212-21.011-13.478-22.532s-1.018-4.555-1.018-4.555-1.9-2.023-1.266-3.922-3.667-8.483-3.667-8.483l3.922-3.667z",
    className: "prefix__cls-4",
    "data-name": "Path 63",
    transform: "translate(-125.877 -169.861)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_64",
    d: "M301.726 412.93l-1.9 1.514-2.277 20.509s1.266 9.109 1.011 10.506 5.194 13.918 5.194 13.918 17.97 32.019 25.311 33.671l24.809-17.723-6.584-8.352s-2.277-.888-2.848 0c0 0-12.212-21.011-13.478-22.532s-1.011-4.555-1.011-4.555-1.9-2.023-1.266-3.922-3.674-8.483-3.674-8.483l3.922-3.667z",
    className: "prefix__cls-3",
    "data-name": "Path 64",
    transform: "translate(-125.188 -169.174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_65",
    d: "M468.381 524.153c1.376 1.672.509 9.178.509 9.178l-3.8 6.288s.227 4.059.241 9.529l-6.385 2a3.791 3.791 0 0 1-4.919-3.736l1.1-35.508 14.9 5.7c-1.266.881.124 3.041.124 3.041s-3.16 1.836-1.77 3.508z",
    className: "prefix__cls-4",
    "data-name": "Path 65",
    transform: "translate(-174.009 -200.053)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_66",
    d: "M469.488 523.046c1.376 1.672.509 9.185.509 9.185l-3.8 6.288s.227 4.052.248 9.529l-6.5 2.03a3.715 3.715 0 0 1-4.816-3.66l1.108-35.618 14.9 5.7c-1.273.881.117 3.034.117 3.034s-3.142 1.847-1.766 3.512z",
    className: "prefix__cls-3",
    "data-name": "Path 66",
    transform: "translate(-174.352 -199.71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_67",
    d: "M477.766 501.488s-1.011 6.46-3.543 6.839-3.667 10.451-6.192 10.093-.853-9.364-.764-11.111-2.752-8.985-.626-10.63 8.855 0 8.855 0z",
    className: "prefix__cls-5",
    "data-name": "Path 67",
    transform: "translate(-177.698 -195.076)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_68",
    d: "M481.975 427.322l4.775-9.632s1.9 7.341 1.9 11.263 2.656 4.307 2.656 4.307 2.91 3.44 1.376 5.944-2.153 8.738-2.153 8.738.5 11.9-1.775 13.54-2.754 5.572-2.754 5.572-4.183 7.465-4.052 9.24-5.82 13.794-5.82 13.794 2.91-14.936-14.049-21.39c0 0-.131-5.071 1.135-6.46s3.24-2.023 2-9.047-.358-15.418-.358-17.1 3.8-12.2 3.8-12.2z",
    className: "prefix__cls-4",
    "data-name": "Path 68",
    transform: "translate(-176.52 -170.66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_69",
    d: "M484.691 415.69l4.169 1.376s1.906 7.341 1.906 11.263 2.656 4.307 2.656 4.307 2.91 3.44 1.376 5.944-2.147 8.738-2.147 8.738.5 11.9-1.775 13.54-2.786 5.573-2.786 5.573-4.176 7.465-4.045 9.24-5.827 13.794-5.827 13.794 2.917-14.936-14.049-21.39c0 0-.124-5.071 1.142-6.46s3.24-2.023 2-9.047-.358-15.418-.358-17.1 3.8-12.2 3.8-12.2z",
    className: "prefix__cls-3",
    "data-name": "Path 69",
    transform: "translate(-177.172 -170.036)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_70",
    d: "M360.15 777.541s6.646-4.176 11.008-1.142-11.008 1.142-11.008 1.142z",
    className: "prefix__cls-4",
    "data-name": "Path 70",
    transform: "translate(-144.719 -282.233)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_71",
    d: "M435.21 759.773a13.454 13.454 0 0 1 10.822 4.562c4.94 5.318-10.822-4.562-10.822-4.562z",
    className: "prefix__cls-4",
    "data-name": "Path 71",
    transform: "translate(-168.138 -277.379)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_45",
    "data-name": "Group 45",
    opacity: 0.1,
    transform: "translate(217.656 127.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_72",
    d: "M425.867 268.774a10.207 10.207 0 0 0-2.5 2.222 25.174 25.174 0 0 0-.881 2.752c-.385.894-1.507 1.624-2.284 1.06-.179-6.192-3.234-12.006-6.983-16.959a17.626 17.626 0 0 0-3.777-3.922 7.4 7.4 0 0 0-5.139-1.452c-2.064.282-3.88 1.686-5.965 1.858-2.752.234-5.222-1.672-7.953-1.768a7.788 7.788 0 0 0-5.834 2.718 15.934 15.934 0 0 0-3.13 5.8 34.015 34.015 0 0 0-1.748 10.017c-.041 1.92-.22 4.314-2 5.029a9.429 9.429 0 0 1 0 1.527c1.789-.688 1.968-3.11 2.009-5.036a33.974 33.974 0 0 1 1.748-10.017 15.969 15.969 0 0 1 3.13-5.807 7.809 7.809 0 0 1 5.834-2.711c2.752.1 5.229 2 7.953 1.768 2.064-.172 3.894-1.582 5.965-1.858a7.4 7.4 0 0 1 5.139 1.452 17.627 17.627 0 0 1 3.777 3.922c3.75 4.947 6.8 10.746 6.983 16.952.777.571 1.9-.172 2.284-1.053a26.691 26.691 0 0 1 .881-2.752 10.181 10.181 0 0 1 2.5-2.215c2.147-1.851 2.683-4.967 2.6-7.8v-.261c-.125 2.454-.776 4.951-2.609 6.534z",
    "data-name": "Path 72",
    transform: "translate(-367.845 -246.152)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_73",
    d: "M370.619 270.762c-1.582-1.741-3.743-2.9-5.194-4.747a10.072 10.072 0 0 1-2-5.635 10.6 10.6 0 0 0 2 7.148c1.452 1.851 3.612 3.013 5.194 4.754a10.32 10.32 0 0 1 2.594 6.137 10.32 10.32 0 0 0-2.594-7.657z",
    "data-name": "Path 73",
    transform: "translate(-363.385 -248.629)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_74",
    d: "M452.7 244.662c-.406 1.686-1.128 3.289-1.459 4.988a15.89 15.89 0 0 0-.213 3.44 13.369 13.369 0 0 1 .213-1.954c.33-1.706 1.053-3.3 1.459-4.988a8.465 8.465 0 0 0 .227-2.848 9.561 9.561 0 0 1-.227 1.362z",
    "data-name": "Path 74",
    transform: "translate(-390.725 -243.3)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "prefix__Ellipse_17",
    cx: 67.038,
    cy: 10.767,
    className: "prefix__cls-1",
    "data-name": "Ellipse 17",
    rx: 67.038,
    ry: 10.767,
    transform: "translate(24.429 501.748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_51",
    fill: "#535461",
    d: "M0 0H4.314V97.125H0z",
    "data-name": "Rectangle 51",
    transform: "translate(89.314 306.253)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_75",
    d: "M195.97 641.521l-.27 4.379-.385 6.192-.158 2.573-.378 6.192-.165 2.573-.385 6.192-4.348 70.224A11.9 11.9 0 0 1 178.006 751H155.4a11.9 11.9 0 0 1-11.868-11.159l-4.332-70.27-.385-6.192-.158-2.573-.385-6.192-.158-2.573-.385-6.192-.275-4.376a6.192 6.192 0 0 1 6.192-6.543h46.24a6.151 6.151 0 0 1 6.082 6.591z",
    className: "prefix__cls-7",
    "data-name": "Path 75",
    transform: "translate(-75.235 -238.439)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_76",
    d: "M148.578 592.24l-.385 6.171H90.965l-.385-6.171z",
    className: "prefix__cls-11",
    "data-name": "Path 76",
    transform: "translate(-28.111 -184.782)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_77",
    d: "M148.281 604.95l-.378 6.178H91.755l-.385-6.178z",
    className: "prefix__cls-11",
    "data-name": "Path 77",
    transform: "translate(-28.358 -188.748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_78",
    d: "M147.984 617.68l-.378 6.171H92.545l-.385-6.171z",
    className: "prefix__cls-11",
    "data-name": "Path 78",
    transform: "translate(-28.604 -192.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_79",
    d: "M103.134 547.969c25.119 18.177 35.6 46.6 35.6 46.6s-30.272-1.039-55.4-19.216-35.59-46.6-35.59-46.6 30.264 1.039 55.39 19.216z",
    className: "prefix__cls-6",
    "data-name": "Path 79",
    transform: "translate(-47.249 -205.314)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_80",
    d: "M47.72 528.76s31.428 17.44 41.507 31.882 49.5 33.932 49.5 33.932",
    className: "prefix__cls-12",
    "data-name": "Path 80",
    transform: "translate(-47.24 -205.314)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_81",
    d: "M138.148 498.718c13.671 9.887 19.388 25.36 19.388 25.36s-16.478-.564-30.155-10.451S108 488.26 108 488.26s16.471.564 30.148 10.458z",
    className: "prefix__cls-6",
    "data-name": "Path 81",
    transform: "translate(-66.048 -192.678)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_82",
    d: "M108 488.26s17.1 9.494 22.587 17.351 26.949 18.466 26.949 18.466",
    className: "prefix__cls-12",
    "data-name": "Path 82",
    transform: "translate(-66.048 -192.678)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_83",
    d: "M200.22 528.884c-15.707 17.262-19.03 39.821-19.03 39.821s22.147-5.435 37.84-22.7 19.03-39.821 19.03-39.821-22.133 5.438-37.84 22.7z",
    className: "prefix__cls-6",
    "data-name": "Path 83",
    transform: "translate(-88.883 -198.269)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_84",
    d: "M238.074 506.19s-20.461 17.7-25.662 29.887-31.221 32.632-31.221 32.632",
    className: "prefix__cls-12",
    "data-name": "Path 84",
    transform: "translate(-88.883 -198.272)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_85",
    fill: "url(#prefix__linear-gradient-2)",
    d: "M976.884 447.152s-11.359-56.512-7.011-63.543c0 0 .158-6.536-.1-14.868v-.956a21.164 21.164 0 0 0 2.387 1.376 19.319 19.319 0 0 0 13 1.679l-3.44-3.832a6.351 6.351 0 0 1-1.864-3.117 6.529 6.529 0 0 1 .743-3.371c3.268-8.256 3.44-18.638-2.855-24.94-5.318-5.3-6.612-12.136-12.384-16.973-4.217-3.543-6.536-8.738-8.724-13.76a77.393 77.393 0 0 1-4.775-13.024c-.826-3.516-1.156-7.155-2.291-10.588s-3.261-6.77-6.584-8.3a24.858 24.858 0 0 1-3.578-1.576c-1.417-.956-2.27-2.511-3.3-3.873-5.208-6.88-22.649-2.828-30.9-.034a17.385 17.385 0 0 0-6.109 3.385l.076-.124c.062-.1.138-.206.206-.31a10.856 10.856 0 0 0-2.312 2.58c-1.2 1.906-1.706 4.128-2.711 6.192-1.211 2.442-7.946 9.26-5.05 12.006a2.442 2.442 0 0 0 .688.44 5.951 5.951 0 0 0 3.44.344l-.124.3a20.111 20.111 0 0 0-1.493 7.63 20.65 20.65 0 0 0 20.833 20.468 21.031 21.031 0 0 0 6.378-.984c.048.261.089.523.138.784a2.4 2.4 0 0 0 .048.31l-.365.509a.7.7 0 0 0-.062-.089l-10.8 15.095c-1.651 1.163-11.159 8.043-11.7 13.2-.564 5.648-1.128 12.26-1.128 12.26l-.076 1.417a4.252 4.252 0 0 1-3.44.929c-3.371-.55-3.371 12.384-3.371 12.384s-2.243 2.064-3.784.275-5.614 4.272-5.614 4.272l-25.525 1.1-.585.034-1.376-4.259a1.8 1.8 0 0 0-2.25-1.149 2.069 2.069 0 0 0-.31.131l-.1.055-.179.124-.089.083a1.375 1.375 0 0 0-.138.144l-.083.1-.041.041a1.734 1.734 0 0 0-.248 1.541l1.183 3.653c-4.926.991-9.962 3.784-5.855 11.476l-20.819-3.846 6.735 5.655 34.771 7.176c-.461.826-.158 2.023 1.28 3.708 6.192 7.272 17.475 9.247 22.016 9.756a39.085 39.085 0 0 0 4.465 7.568l-.392 7.245s-11.5 55.219-13.6 58.019a32.723 32.723 0 0 0 2.91-3.832c-3.337 11.345-8 26.873-9.226 29.2-1.968 3.715-3.791 18.748-1.548 19.711.688.3 2.656.151 5.463-.062v1.245l-.124 47.19s.564 28.944-.984 31.7-1.961 8.545-1.961 8.545-6.192 11.414-11.1 16a.747.747 0 0 1-.11.1l-.151-1.073s-5.9 7.444-18.941 7.024c0 0-7.85 5.1 3.791 5.38s26.509-.413 26.509-.413 10.382-15.824 19.078-13.76v11.985h2.663v-12.185a10.919 10.919 0 0 0 4.74-7.176 8.724 8.724 0 0 0-3.11-8.07 5.16 5.16 0 0 1-1.7-3.77l-.1.083a7.256 7.256 0 0 0-.089-.743c-.764-6.192-1.72-18.968 1.658-28.421 4.63-12.962 6.034-31.015 2.663-41.761a96.019 96.019 0 0 1-2.676-10.464c-.083-.447-.158-.874-.227-1.273a54.234 54.234 0 0 1 6.832 1.376c7.809 2.153 24.892 2.552 39.477 2.436.034.4.076.819.124 1.238a45.073 45.073 0 0 0 1.624 8.614c1.83 5.5 2.669 29.77 2.669 29.77s2.36 19.952 1.073 28.07c-.688 4.513-1.376 9.047-1.768 13.6v.089s-3.866 11.008-6.694 16.987c-.069.151-.144.3-.213.447a8.944 8.944 0 0 0-2.208.489s-3.791 7.568-7.568 8.82-2.525 5.373 6.027 3.86 21.465-2.752 21.465-2.752l.557-7.719 2.628-3.289-.688 7.7 2.8-.55-.371-9.364 4.3-5.38s5.194-4.623-2.525-13.719v.2c-.083-.131-.158-.268-.248-.4v-.041c-1.28-1.981-2.3-5.676-.433-12.233 3.371-11.847 5.332-22.6 5.332-22.6s7.527-28.806-1.52-42.436h.4a22.924 22.924 0 0 1-1.936-6.053q-.069-.372-.124-.764c6.694-.385 13.265-1.6 18.624-4.211-.02-.025-3.246-68.389-5.916-79.273zM891.9 399.474v.138l-1.376.069zm-4.72.654a1.52 1.52 0 0 0-.619.3 6.109 6.109 0 0 0-1.08 2.828l-2.146-.482s-1.507-.323-3.674-.688l-1.025-1.032c2.816-.239 5.747-.583 8.54-.927z",
    "data-name": "Path 85",
    transform: "translate(-288.964 -122.612)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_86",
    d: "M972.139 742.906l-.819 9.749 2.745-.55-.413-10.575z",
    className: "prefix__cls-14",
    "data-name": "Path 86",
    transform: "translate(-302.904 -231.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_87",
    d: "M911.745 708.413c-3.309 9.426-2.374 22.147-1.631 28.325.275 2.284.53 3.674.53 3.674s-4.947 11.269-5.359 11.7-14.558 9.061-14.558 9.061l-9.886 5.772s-10.031-4.4-5.222-5.91a7.3 7.3 0 0 0 2.594-1.768c4.816-4.575 10.863-15.948 10.863-15.948s.413-5.772 1.926-8.517.963-31.593.963-31.593l.117-47.025v-6.13l18.817.138a42.6 42.6 0 0 0 .812 6.192 94.669 94.669 0 0 0 2.621 10.43c3.316 10.722 1.94 28.686-2.587 41.599z",
    className: "prefix__cls-15",
    "data-name": "Path 87",
    transform: "translate(-305.139 -243.156)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_88",
    d: "M910.644 779.73s-4.947 11.269-5.359 11.7-14.558 9.061-14.558 9.061l-9.886 5.772s-10.031-4.4-5.222-5.91a7.3 7.3 0 0 0 2.594-1.768l.427 3.006 3.3-.138 28.208-25.38c.242 2.267.496 3.657.496 3.657z",
    className: "prefix__cls-4",
    "data-name": "Path 88",
    transform: "translate(-305.139 -282.475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_89",
    d: "M902.375 777l-28.366 25.552-3.3.138-.688-4.816s-5.765 7.417-18.576 7c0 0-7.692 5.084 3.708 5.359s25.958-.413 25.958-.413 10.169-15.824 18.679-13.76v11.95h2.614v-12.056a10.863 10.863 0 0 0 4.637-7.155 8.765 8.765 0 0 0-3.034-8.036 5.18 5.18 0 0 1-1.632-3.763z",
    className: "prefix__cls-14",
    "data-name": "Path 89",
    transform: "translate(-297.214 -282.765)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_90",
    d: "M1011.964 722.876c-1.83 6.536-.832 10.217.42 12.191v.041a22.533 22.533 0 0 1 3.289 8.029l.11.619-12.907 18.817-7 2.752s-11.263-3.846-9.205-4.947c.516-.268 1.321-1.7 2.243-3.674 2.752-5.951 6.55-16.932 6.55-16.932v-.089c.4-4.534 1.032-9.054 1.734-13.554 1.259-8.1-1.053-27.974-1.053-27.974s-.826-24.169-2.614-29.666a45.362 45.362 0 0 1-1.6-8.559c-.372-3.44-.454-6.275-.454-6.275s7.417-10.32 21.011.826a14.956 14.956 0 0 1 2.841 3.082c9.391 13.361 1.83 42.793 1.83 42.793s-1.9 10.707-5.195 22.52z",
    className: "prefix__cls-15",
    "data-name": "Path 90",
    transform: "translate(-340.115 -242.924)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_91",
    d: "M1015.812 782.575l-12.907 18.817-7 2.752s-11.266-3.844-9.205-4.944c.516-.268 1.321-1.7 2.243-3.674 4.768-.041 7.238 4.5 7.238 4.5l6.041-.963s7.967-15.659 9.756-16.615.275-7.148.275-7.148v-1.58c.048.055.089.117.145.172v.041a22.532 22.532 0 0 1 3.289 8.029z",
    className: "prefix__cls-4",
    "data-name": "Path 91",
    transform: "translate(-340.125 -281.742)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_92",
    d: "M992.379 800.609s-3.44-6.316-10.031-3.983c0 0-3.708 7.568-7.417 8.793s-2.47 5.353 5.91 3.846 21.011-2.752 21.011-2.752l.55-7.7 8.517-10.85s5.078-4.6-2.477-13.664v1.576s1.514 6.192-.275 7.148-9.728 16.622-9.728 16.622z",
    className: "prefix__cls-14",
    "data-name": "Path 92",
    transform: "translate(-335.914 -281.923)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_93",
    d: "M918.977 650.168a42.584 42.584 0 0 0 .812 6.192 86.313 86.313 0 0 0-19.649-.2v-6.13z",
    className: "prefix__cls-4",
    "data-name": "Path 93",
    transform: "translate(-313.197 -243.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_94",
    d: "M1018.389 659.274s-11.008.537-24.135.647c-.372-3.44-.454-6.275-.454-6.275s7.417-10.32 21.011.826a14.957 14.957 0 0 1 2.841 3.082 16.812 16.812 0 0 0 .737 1.72z",
    className: "prefix__cls-4",
    "data-name": "Path 94",
    transform: "translate(-342.419 -242.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_95",
    d: "M986.287 603.384s-48.215 2.332-62.91-1.789-29.261-.55-31.455-1.507-.413-15.934 1.514-19.642 12.494-41.211 12.494-41.211l10.17-53.017 10.712-2.952.757-.213 18.665-5.146 13.677-3.777s27.2 106.179 24.864 114.008a20.048 20.048 0 0 0-.4 9.212 23 23 0 0 0 1.912 6.034z",
    className: "prefix__cls-14",
    "data-name": "Path 95",
    transform: "translate(-310.317 -188.269)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_96",
    fill: "#c7daf5",
    d: "M873.7 439s-9.632 10.32-2.339 16.072 12.088.55 12.088.55z",
    "data-name": "Path 96",
    transform: "translate(-303.367 -177.308)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_97",
    d: "M873.7 439s-9.632 10.32-2.339 16.072 12.088.55 12.088.55z",
    className: "prefix__cls-4",
    "data-name": "Path 97",
    transform: "translate(-303.367 -177.308)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_98",
    d: "M979.766 331.849s-1.128 1.073-2.828 2.656c-2.422 2.263-6.006 5.573-9.185 8.345-4.4 3.832-8.036 6.646-6.735 4.245s1.053-6.584.406-10.5c-.048-.261-.089-.523-.138-.777a72.1 72.1 0 0 0-2.126-8.5s7.114-9.192 11.049-12.817c1.465-1.376 2.491-1.94 2.552-.984a31.967 31.967 0 0 0 2.229 7.141c.034.1.069.186.11.282.8 2.064 1.7 4.183 2.491 6.013 1.209 2.805 2.175 4.896 2.175 4.896z",
    className: "prefix__cls-15",
    "data-name": "Path 98",
    transform: "translate(-331.612 -138.008)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_99",
    d: "M975.1 320.941a20.42 20.42 0 0 1-13.677 15.659 71.593 71.593 0 0 0-2.263-9.281s13.4-17.3 13.6-13.8c.05 1.327 1.096 4.271 2.34 7.422z",
    className: "prefix__cls-4",
    "data-name": "Path 99",
    transform: "translate(-331.612 -138.012)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_100",
    d: "M948.829 352.892l1.734-2.442s1.149 7 5.373 3.915 4.431 23.247 4.431 23.247l-4.534 67.788-32.763-1.96.93-32.756 3.708-16.512 9.171-24 5.456-7.933z",
    className: "prefix__cls-4",
    "data-name": "Path 100",
    transform: "translate(-320.351 -149.681)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_101",
    d: "M960.376 378.207l-4.128 61.293-.433 6.495-18.267-1.095-.688-.041-13.76-.826.929-32.762 3.708-16.512 9.171-24 5.456-7.933 6.495-9.377 1.734-2.436s1.149 7 5.373 3.915l.089-.062c4.128-2.618 4.321 23.341 4.321 23.341z",
    className: "prefix__cls-14",
    "data-name": "Path 101",
    transform: "translate(-320.361 -149.855)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_102",
    d: "M911.256 406.26s-1.644 3.44-4.947 2.883-3.3 12.384-3.3 12.384-2.195 2.064-3.708.275-5.5 4.259-5.5 4.259l-25 1.1s11.125 5.084 8.944 20.468c0 0 37.771-2.339 39.009-5.91s-5.498-35.459-5.498-35.459z",
    className: "prefix__cls-3",
    "data-name": "Path 102",
    transform: "translate(-303.419 -167.093)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_103",
    d: "M911.256 406.26s-1.644 3.44-4.947 2.883-3.3 12.384-3.3 12.384-2.195 2.064-3.708.275-5.5 4.259-5.5 4.259l-25 1.1s11.125 5.084 8.944 20.468c0 0 37.771-2.339 39.009-5.91s-5.498-35.459-5.498-35.459z",
    className: "prefix__cls-17",
    "data-name": "Path 103",
    transform: "translate(-303.419 -167.093)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_104",
    d: "M777.66 389.76l6.591 5.628 54.255 11.4-6.729-6.866z",
    className: "prefix__cls-3",
    "data-name": "Path 104",
    transform: "translate(-242.482 -121.608)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_105",
    d: "M942.848 354.233c-.9 1.376-3.481 8.421-5.635 14.572-1.8 5.126-3.3 9.632-3.3 9.632s-3.5 22.8-5.291 26.921-.819 20.193-.819 20.193l-6.667 39.691s-3.02 20.468-7.685 32.694c-4.6 12.033-9.728 17.675-9.886 17.854C905.634 513 916.883 458 916.883 458l3.715-69.364s.543-6.591 1.094-12.226 11.7-13.327 11.7-13.327l10.747-15.28c1.075 1.442.353 3.96-1.291 6.43z",
    className: "prefix__cls-3",
    "data-name": "Path 105",
    transform: "translate(-314.267 -148.854)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_106",
    d: "M908.624 479.82s-15.824-.688-23.488-9.893 17.716-3.674 17.716-3.674l6.6 1.514z",
    className: "prefix__cls-15",
    "data-name": "Path 106",
    transform: "translate(-308.066 -185.297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_107",
    d: "M1001.054 551.424a20.047 20.047 0 0 0-.4 9.212c-17.262 1.225-35.728-3.44-35.728-3.44-3.44 3.165-12.5 7.829-12.5 7.829l-4.94-61.232c-3.158-8.256-4.4-51.51-4.4-51.51s.282-2.264.688-5.655a.653.653 0 0 1 .034-.255c1.232-9.474 3.674-27.258 4.871-29.66 1.651-3.3-5.077-12.088-5.077-12.088l3.062-26.11.372-3.151c6.453-2.883 11.4-12.088 11.4-12.088l3.8-6.653c4.128-2.649 4.341 23.309 4.341 23.309l-4.128 61.294 13.677-3.777s27.26 106.145 24.928 113.975z",
    className: "prefix__cls-4",
    "data-name": "Path 107",
    transform: "translate(-326.598 -151.548)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_108",
    d: "M1019.144 548.218c-18.817 9.343-53.017.688-53.017.688-3.44 3.165-12.5 7.829-12.5 7.829l-4.948-61.235c-3.151-8.256-4.39-51.51-4.39-51.51s3.977-32.274 5.628-35.569c.482-.963.248-2.394-.323-3.935a49.8 49.8 0 0 1-3.014-23.041l1.321-11.221.365-3.144c6.46-2.89 11.407-12.1 11.407-12.1l3.44-6.027 6.33-11.1 3-5.256.509.461 3.887 3.523 4.128 3.44c5.387 4.541 14.7 12.535 19.5 17.427 4.224 4.307 5.559 21.06 5.944 33.671.255 8.3.1 14.813.1 14.813-4.259 7.011 6.88 63.3 6.88 63.3 2.595 10.875 5.753 78.986 5.753 78.986z",
    className: "prefix__cls-3",
    "data-name": "Path 108",
    transform: "translate(-326.972 -144.111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_109",
    d: "M974.333 364.5s-12.914 24.582-11.414 33.925 5.766 19.918 3.708 22.387a7.6 7.6 0 0 1-6.047 3.02c-2.064.138-7.568 3.983-7.568 4.4s-5.084.413-9.632 2.339a59.973 59.973 0 0 1-11.263 3.02s-13.072-.413-14.29.826-2.47 8.648.138 14.558 5.5 10.32 7.692 11.125 16.072-3.846 27.334-4.947 23.488-10.024 23.488-10.024 13.464-4.816 15.824-12.914-2.883-52.6-2.883-52.6-3.962-20.75-15.087-15.115z",
    className: "prefix__cls-17",
    "data-name": "Path 109",
    transform: "translate(-318.28 -153.761)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_110",
    d: "M971.942 361.5s-12.914 24.589-11.4 33.925 5.766 19.918 3.7 22.394a7.568 7.568 0 0 1-6.041 3.02c-2.064.138-7.568 3.983-7.568 4.4s-5.084.413-9.632 2.332a60.563 60.563 0 0 1-11.263 3.02s-13.072-.413-14.283.826-2.477 8.655.138 14.558 5.5 10.32 7.692 11.125 16.072-3.846 27.334-4.94 23.488-10.031 23.488-10.031 13.457-4.816 15.789-12.907-2.883-52.611-2.883-52.611-3.946-20.738-15.071-15.111z",
    className: "prefix__cls-17",
    "data-name": "Path 110",
    transform: "translate(-317.541 -152.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_111",
    d: "M973.749 362.7s-12.914 24.589-11.4 33.925 5.765 19.918 3.708 22.387a7.568 7.568 0 0 1-6.047 3.027c-2.064.138-7.568 3.984-7.568 4.389s-5.077.413-9.632 2.339a60.116 60.116 0 0 1-11.263 3.02s-13.072-.413-14.29.826-2.47 8.655.138 14.558 5.5 10.32 7.692 11.125 16.072-3.846 27.334-4.947 23.488-10.024 23.488-10.024 13.464-4.816 15.824-12.914-2.848-52.6-2.848-52.6-4.018-20.711-15.136-15.111z",
    className: "prefix__cls-3",
    "data-name": "Path 111",
    transform: "translate(-318.103 -153.204)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_112",
    d: "M996.194 458.722s-10.32-2.064-6.729 1.376 3.571 6.453 7.967 6.316-1.238-7.692-1.238-7.692z",
    className: "prefix__cls-4",
    "data-name": "Path 112",
    transform: "translate(-340.83 -183.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_113",
    d: "M1024.387 566.58s-4.665 3.158 4.259 10.437-4.259-10.437-4.259-10.437z",
    className: "prefix__cls-4",
    "data-name": "Path 113",
    transform: "translate(-351.582 -217.114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_114",
    d: "M1011.909 604.31c0 .413-1.651 15.136 4.527 18.817s-4.527-18.817-4.527-18.817z",
    className: "prefix__cls-4",
    "data-name": "Path 114",
    transform: "translate(-348.007 -228.885)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_115",
    d: "M864.1 436.59c-4.981.172-15.741 1.692-10.162 12.1 4.933 9.212 13.223 3.055 17.888-1.617a17.579 17.579 0 0 0-7.726-10.483z",
    className: "prefix__cls-15",
    "data-name": "Path 115",
    transform: "translate(-298.295 -176.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_117",
    d: "M880.74 451.613l.206-.213z",
    className: "prefix__cls-15",
    "data-name": "Path 117",
    transform: "translate(-307.144 -181.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_118",
    d: "M982.605 340.627c-5.284 3.612-9.715 6.66-10.581 7.293-2.367 1.754-6.88 12.054-9.79 17.31-2.319 4.231-9.852 5.318-12.694 5.587l.365-3.144c6.46-2.89 11.407-12.095 11.407-12.095l12.769-22.387 4.4 4z",
    className: "prefix__cls-4",
    "data-name": "Path 118",
    transform: "translate(-328.61 -144.295)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_119",
    d: "M982.605 340.027c-5.284 3.612-9.715 6.66-10.581 7.3-2.367 1.747-6.88 12.047-9.79 17.3-2.319 4.231-9.852 5.318-12.694 5.587l.365-3.144c6.46-2.89 11.407-12.095 11.407-12.095l12.769-22.387 4.4 3.984s1.647 1.364 4.124 3.455z",
    className: "prefix__cls-18",
    "data-name": "Path 119",
    transform: "translate(-328.61 -144.108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_120",
    d: "M964.311 308.667a20.406 20.406 0 1 1-17.348-20.167 20.372 20.372 0 0 1 17.347 20.172z",
    className: "prefix__cls-15",
    "data-name": "Path 120",
    transform: "translate(-320.484 -130.278)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_121",
    d: "M1000.594 377.294a18.136 18.136 0 0 1-6.584-7.073c-1.149-2.27-1.913-4.892-3.873-6.5-1.768-1.445-4.128-1.8-6.33-2.442-7.238-2.14-13.306-8.744-13.533-16.285-.11-3.55 1-7.093.5-10.609a11.75 11.75 0 0 0-2.3-5.47 18.838 18.838 0 0 0-1.988-2.14c-.963-.908-1.975-1.789-2.855-2.752a10.685 10.685 0 0 1-1.445-1.961 9.438 9.438 0 0 1-.791-1.823c-1.376-4.211-.124-9.205-1.637-13.464l-.083-.234c-.571-1.514-1.734-3.027-3.351-3.144s-3 1.225-4.541 1.823c-3.227 1.252-6.708-.881-9.4-3.055s-5.724-4.658-9.143-4.176c-2.264.323-4.052 1.864-6.137 2.663a8.608 8.608 0 0 1-1.452.42 20.4 20.4 0 0 1 39.333 7.6 20.185 20.185 0 0 1-.447 4.259c.034.1.069.186.11.282.8 2.064 1.7 4.183 2.491 6.013l3.887 3.523 4.128 3.44c5.387 4.541 14.7 12.535 19.5 17.427 4.221 4.322 5.542 21.067 5.941 33.678z",
    className: "prefix__cls-4",
    "data-name": "Path 121",
    transform: "translate(-321.156 -130.278)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_122",
    fill: "#591d4b",
    d: "M924.849 280.981c.984-2 1.472-4.245 2.649-6.144 1.727-2.752 4.74-4.513 7.836-5.58 8.084-2.786 25.167-6.832 30.272 0 1 1.376 1.837 2.9 3.227 3.853a23.958 23.958 0 0 0 3.5 1.576c3.254 1.527 5.332 4.857 6.44 8.256s1.438 7.045 2.25 10.547a77.56 77.56 0 0 0 4.678 12.983c2.14 4.995 4.41 10.175 8.538 13.7 5.635 4.816 6.88 11.634 12.109 16.918 6.192 6.275 5.992 16.629 2.8 24.85a6.823 6.823 0 0 0-.729 3.357 6.583 6.583 0 0 0 1.823 3.11l3.385 3.818a19.034 19.034 0 0 1-20.8-9.591c-1.149-2.27-1.913-4.885-3.88-6.5-1.761-1.445-4.128-1.789-6.323-2.436-7.238-2.147-13.306-8.758-13.533-16.3-.11-3.543 1-7.086.5-10.6a11.7 11.7 0 0 0-2.3-5.5c-1.892-2.47-4.747-4.128-6.288-6.88-2.607-4.6-.626-10.581-2.5-15.521-.578-1.514-1.734-3.027-3.351-3.144s-3 1.225-4.548 1.823c-3.22 1.252-6.7-.874-9.391-3.055s-5.724-4.658-9.15-4.169c-2.264.316-4.045 1.858-6.13 2.663-1.541.592-4.665 1.121-6.013-.179-2.859-2.615 3.739-9.406 4.929-11.855z",
    "data-name": "Path 122",
    transform: "translate(-319.145 -123.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_123",
    d: "M994.676 363.4c-1.156-2.27-1.913-4.885-3.88-6.495-1.761-1.445-4.128-1.8-6.33-2.442-7.231-2.14-13.3-8.751-13.533-16.292-.11-3.543 1-7.093.5-10.6a11.765 11.765 0 0 0-2.3-5.47c-1.9-2.47-4.754-4.128-6.288-6.88-2.607-4.6-.626-10.575-2.511-15.521-.571-1.507-1.734-3.02-3.344-3.144s-3.007 1.232-4.548 1.83c-3.22 1.252-6.708-.881-9.391-3.055s-5.731-4.658-9.15-4.176c-2.264.323-4.052 1.864-6.13 2.663-1.541.592-4.672 1.128-6.02-.172-2.835-2.752 3.763-9.529 4.947-11.964.984-2.009 1.472-4.245 2.656-6.144.062-.1.131-.206.2-.31a10.926 10.926 0 0 0-2.263 2.573c-1.176 1.9-1.665 4.128-2.649 6.144-1.19 2.436-7.788 9.233-4.947 11.964 1.376 1.307 4.472.771 6.013.179 2.064-.8 3.867-2.346 6.13-2.663 3.44-.488 6.467 2 9.15 4.169s6.192 4.307 9.4 3.055c1.541-.6 2.89-1.947 4.541-1.823s2.752 1.631 3.351 3.144c1.878 4.94-.1 10.919 2.5 15.521 1.541 2.7 4.4 4.4 6.288 6.88a11.7 11.7 0 0 1 2.3 5.5c.5 3.509-.606 7.052-.5 10.6.227 7.568 6.3 14.152 13.533 16.3 2.181.647 4.561.991 6.323 2.435 1.975 1.617 2.752 4.231 3.88 6.5a19.034 19.034 0 0 0 20.8 9.591l-1.6-1.8a19.24 19.24 0 0 1-17.128-10.097z",
    className: "prefix__cls-4",
    "data-name": "Path 123",
    transform: "translate(-319.077 -126.212)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_124",
    d: "M955.761 354.8c-.9 1.376-3.481 8.421-5.635 14.572-2.016-.784-3.846-5.786-3.846-5.786l10.747-15.286c1.1 1.514.373 4.025-1.266 6.5z",
    className: "prefix__cls-4",
    "data-name": "Path 124",
    transform: "translate(-327.593 -149.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_125",
    d: "M956.361 354.2c-.9 1.376-3.481 8.421-5.635 14.572-2.016-.777-3.846-5.786-3.846-5.786l10.747-15.28c1.1 1.511.373 4.029-1.266 6.494z",
    className: "prefix__cls-18",
    "data-name": "Path 125",
    transform: "translate(-327.78 -148.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_126",
    fill: "#be8b87",
    d: "M867.1 449.751l-5.958-18.789a1.754 1.754 0 0 1 1.142-2.208 1.761 1.761 0 0 1 2.2 1.142l5.958 18.769-.592 3.928z",
    "data-name": "Path 126",
    transform: "translate(-301.004 -174.086)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_127",
    fill: "#fff",
    d: "M861.835 429.323a1.761 1.761 0 0 1 2.208 1.142L870 449.234l-.447 2.945.433.454.592-3.928-5.992-18.769a1.761 1.761 0 0 0-2.2-1.142 1.761 1.761 0 0 0-.915.688 2.4 2.4 0 0 1 .364-.159z",
    "data-name": "Path 127",
    opacity: 0.1,
    transform: "translate(-301.132 -174.099)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_128",
    fill: "#efc8c4",
    d: "M822.6 400.2l3.344-1.06-.488 3.22-.1.709-.977-1.018z",
    "data-name": "Path 128",
    transform: "translate(-256.503 -124.535)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_129",
    fill: "#727a9c",
    d: "M872.42 461.9a.688.688 0 0 1 .213-.179.3.3 0 0 1 .323 0 .853.853 0 0 1 .117.186.592.592 0 0 0 .427.282l-.1.688z",
    "data-name": "Path 129",
    transform: "translate(-304.548 -184.382)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_130",
    d: "M861.13 441.7s11.951-.069 9.137 5.016-7.21 5.7-7.21 5.7z",
    className: "prefix__cls-15",
    "data-name": "Path 130",
    transform: "translate(-301.026 -178.151)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_131",
    d: "M681.8 110.05h-.516a58.847 58.847 0 0 0-49.13 26.894 58.847 58.847 0 0 0-49.13-26.894h-.516a58.48 58.48 0 0 0-57.918 58.45c0 19.133 8.38 46.282 24.72 68.621 31.132 42.566 82.849 79.808 82.849 79.808S683.875 279.69 715 237.116c16.347-22.339 24.72-49.488 24.72-68.621a58.48 58.48 0 0 0-57.92-58.445zm-7.382 130.341a11.593 11.593 0 0 1-10.781-7.444h-12.27a3.88 3.88 0 0 1-3.653-2.642l-3.77-11.359-11.93 41.686a3.86 3.86 0 0 1-3.7 2.786h-.241a3.811 3.811 0 0 1-3.578-3.192L612.2 186.28l-8.985 43.757a3.832 3.832 0 0 1-3.722 2.91H582.2a3.846 3.846 0 1 1 0-7.685h14.262l12.728-58.831a3.86 3.86 0 0 1 7.568.316l12.556 75.432 10.691-37.3a3.784 3.784 0 0 1 3.6-2.752h.076a3.839 3.839 0 0 1 3.646 2.642l6.818 20.509h9.343a11.531 11.531 0 1 1 10.953 15.136z",
    className: "prefix__cls-6",
    "data-name": "Path 131",
    transform: "translate(-196.025 -74.675)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptoHome);
export default __webpack_public_path__ + "static/media/opto-home.e245dee4cdc5ec3bddfda25cf0c55805.svg";
export { ForwardRef as ReactComponent };